import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';

const WalkDryIsland = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity("DRY_ISLAND"));
  }

  return (
    <div>
      <h2 className="walks-link-heading"><a  onClick={navigateToActivity}>Dry Island</a></h2>
      <p className="walk-text">An island around high tide but easy to walk to and explore at other times.  Great views and a secluded cove on the far side.
      </p>    
    </div>
  );
}

export default WalkDryIsland
